<template>
  <div
    class="flex-col justify-start relative page"
    :style="`background-image: url('${loginBg}')`"
  >
    <div class="section"></div>
    <div class="title-box">
      <span class="text_2 pos_2">EECA</span>
      <span class="text pos">电工行业高质量发展合格评定创新(EECA)平台</span>
    </div>
    <div class="flex-col section_2 pos_3">
      <span class="self-center font text_3">欢迎注册</span>
      <div class="mt-32 flex-col self-stretch">
        <el-input class="input" placeholder="请使用邮箱注册" v-model="account"></el-input>
        <el-input type="password" class="input" placeholder="请输入8-20位密码" v-model="password"></el-input>
        <el-input type="password" class="input" placeholder="请再次输入密码" v-model="password2"></el-input>

        <div class="flex-col self-stretch group view_2">
          <div class="flex-row self-stretch">
            <el-input class="input valiCode noBottom" placeholder="请输入图片验证码" v-model="valiCode"></el-input>
            <img
              class="ml-28 shrink-0 image"
              src="https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=b1068604a4b54a5b111a4287c21b7bf5.png"
            />
          </div>
          <span class="self-end font_3 text_8 mt-7" @click="changeCode">换一个</span>
        </div>
        <div class="flex-row items-center self-stretch group_2">
          <el-checkbox class="btn" v-model="checked">我已阅读并同意</el-checkbox>
          <span class="word">《会员协议》</span>
        </div>
        <div class="flex-col justify-start items-center self-center text-wrapper_4" @click="sumit">
          <span class="font text_11">新用户注册</span>
        </div>
        <span class="self-end font_3 text_12" @click="goLogin">已有帐号去登录</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    const { loginBg } = this.$images
    return {
      loginBg,
      account: '',
      password: '',
      password2: '',
      valiCode: '',
      checked: false
    }
  },

  methods: {
    // todo 去注册
    sumit () {
      // 1.判断账号不为空
      // 2.判断密码不为空
      // 3.判断输入两次密码要一致
      // 4.判断验证码是否输入正确
      // 5.判断已勾选同意书
      // 6.以上5点通过就去注册->跳转首页
    },
    changeCode () {
      // 更新验证码
    },
    goLogin () {
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style scoped lang="less">
.self-stretch{
  width: 445px;
}
  .word{
    font-weight: normal;
    font-size: 16px;
    color: #1D66D6;
  }
  .mt-7 {
    margin-top: 7px;
  }
  .ml-7 {
    margin-left: 7px;
  }
  .page {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 1080px;
    .section {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 1080px;
      min-width: calc(100vw);
    }
    .text {
      color: #ffffff;
      font-size: 45px;
      line-height: 35px;
      text-transform: uppercase;
    }
    .title-box{
      position: absolute;
      top: 141px;
      width: 100%;
      text-align: center;
    }
    .pos {
      /*position: absolute;*/
      left: 510px;
      top: 139px;
    }
    .text_2 {
      color: #ffffff;
      font-size: 50px;
      line-height: 40px;
      font-weight: bold;
      margin-right: 10px;
    }
    .pos_2 {
      /*position: absolute;*/
      right: 492px;
      top: 138px;
    }
    .section_2 {
      padding: 62px 107px 65px;
      background-color: #ffffff;
      border-radius: 5px;
      .font {
        font-size: 20px;
        font-family: PingFang;
        line-height: 20px;
      }
      .text_3 {
        color: #333333;
      }
      .text-wrapper {
        padding: 15px 0 18px;
        background-color: #ffffff;
        border-radius: 4px;
        width: 446px;
        border-left: solid 1px #e5e5e5;
        border-right: solid 1px #e5e5e5;
        border-top: solid 1px #e5e5e5;
        border-bottom: solid 1px #e5e5e5;
        .text_4 {
          margin-left: 21px;
        }
      }
      .group {
        .text-wrapper_2 {
          padding: 16px 0;
          background-color: #ffffff;
          border-radius: 4px;
          width: 446px;
          border-left: solid 1px #e5e5e5;
          border-right: solid 1px #e5e5e5;
          border-top: solid 1px #e5e5e5;
          border-bottom: solid 1px #e5e5e5;
          .text_5 {
            margin-left: 21px;
          }
          .text_6 {
            line-height: 14px;
          }
        }
        .text-wrapper_3 {
          padding: 14px 0 18px;
          background-color: #ffffff;
          border-radius: 4px;
          height: 48px;
          border-left: solid 1px #e5e5e5;
          border-right: solid 1px #e5e5e5;
          border-top: solid 1px #e5e5e5;
          border-bottom: solid 1px #e5e5e5;
          .text_7 {
            margin-left: 21px;
            line-height: 14px;
          }
        }
        .image {
          border-radius: 4px;
          width: 129px;
          height: 49px;
        }
        .text_8 {
          margin-right: 5px;
        }
      }
      .view {
        margin-top: 23px;
      }
      .font_2 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 13px;
        color: #999999;
      }
      .group_2 {
        margin-top: 54px;

        .btn{

          /deep/ .el-checkbox__label {
            position: relative;
            top: 1px;
            font-size: 16px;
            padding-left: 7px;
          }

          /deep/ .el-checkbox__inner{
            width: 16px;
            height: 16px;

            &:after{
              left: 5px;
            }
          }
        }
        .image_2 {
          width: 20px;
          height: 20px;
        }
        .group_3 {
          line-height: 16px;
          height: 16px;
          .font_4 {
            font-size: 16px;
            font-family: PingFang;
            line-height: 16px;
          }
          .text_9 {
            color: #999999;
          }
          .text_10 {
            color: #1d66d6;
          }
        }
      }
      .text-wrapper_4 {
        margin-top: 19px;
        padding: 14px 0;
        background-color: #006ed1;
        border-radius: 4px;
        width: 355px;
        cursor: pointer;
        .text_11 {
          color: #ffffff;
        }
      }
      .font_3 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 13px;
        color: #666666;
        cursor: pointer;
      }
      .text_12 {
        margin-right: 46px;
        margin-top: 21px;
        cursor: pointer;
      }
    }
    .pos_3 {
      position: absolute;
      left: 50%;
      top: 239px;
      transform: translateX(-50%);

      .input{
        margin-bottom: 23px;

        /deep/ input {
          height: 48px;
          padding: 0px 22px
        }

        &.valiCode{
          width: 289px;
        }
        &.noBottom{
          margin-bottom: 0px;
        }
      }
    }
  }
</style>
